import React, { Fragment } from 'react';
import FormNfe from '../../../components/nota-fiscal/form-nfe';
import NavBar from '../../../components/layout/navbar/index';

export default function Nfe(props) {
    const nfeTemp = props.location.state.registroUnico;
    const pessoaToNfe = props.location.state.pessoa;
    return (
        <Fragment>
            <NavBar />
            <FormNfe nfeDados={nfeTemp ? nfeTemp : {}} pessoaToNfe={pessoaToNfe} />
        </Fragment>
    )
}